import React, { FunctionComponent } from 'react';
import clsx from 'clsx';
import { Grid } from '@material-ui/core';
import Price from '../../../../../../common/components/presentation/Price';
import labelAndPriceStyles from './LabelAndPriceStyles';

export interface ILabelAndPriceProps {
  label: string | JSX.Element;
  price: number;
  currency: string;
  priceType: string;
  decimals?: number;
  boldLabel?: boolean;
  boldPrice?: string;
  showSign?: boolean;
  isMainText?: boolean;
  loading?: boolean;
  labelClassNames?: string;
  priceClassNames?: string;
}

const LabelAndPrice: FunctionComponent<ILabelAndPriceProps> = ({
  label,
  price,
  currency,
  decimals,
  priceType,
  boldLabel = false,
  showSign = false,
  isMainText = true,
  boldPrice = true,
  loading,
  labelClassNames,
  priceClassNames,
}) => {
  const styles = labelAndPriceStyles();

  return (
    <Grid container={true} justifyContent={'space-between'} spacing={3} className={styles.lineContainer}>
      <Grid
        item={true}
        sm={9}
        xs={6}
        className={clsx(labelClassNames, [
          {
            [styles.listText]: !isMainText,
            [styles.boldLabel]: boldLabel,
          },
        ])}
      >
        {label}
      </Grid>
      <Grid item={true} sm={3} xs={6} className={styles.priceContainer} data-test={`summary:price:${priceType}`}>
        {showSign && '- '}

        <Price
          loading={loading}
          price={price}
          currency={currency}
          variant="caption"
          decimals={decimals}
          className={clsx(priceClassNames, [
            { [styles.boldLabel]: boldPrice },
            !isMainText ? styles.listText : styles.price,
          ])}
        />
      </Grid>
    </Grid>
  );
};

export default LabelAndPrice;
